module.exports = __webpack_public_path__ + "static/media/noshow-driver.70cf0a02.png";